import classNames from "classnames";

import Button from "@/common/Button";
import { logAnalyticsEvent, setAnalyticsUserProperties } from "@/constants/amplitude";
import { WebEventProps, WebEventTypes } from "@/constants/event";
import { sendMetrics } from "@/constants/gtag";
import { QuestionTypes } from "@/constants/questionsIds";
import { QuestionComponentProps } from "@/types/common";

const YesNoWithImage = ({
    handleNext,
    question,
}: QuestionComponentProps<QuestionTypes.YesNoWithImage>) => {
    const sendAnalyticsEvents = (value: string) => {
        logAnalyticsEvent(WebEventTypes.RESULT_EVENT, {
            [WebEventProps.SCREEN]: question.event,
            [WebEventProps.RESULT]: value,
        });
        setAnalyticsUserProperties({ [question.id]: value });
        sendMetrics(WebEventTypes.RESULT_EVENT, {
            [WebEventProps.SCREEN]: question.event,
            [WebEventProps.RESULT]: value,
        });
    };
    const handleContinue = (ansId: string) => () => {
        sendAnalyticsEvents(ansId);
        handleNext({ [question.id]: ansId });
    };

    return (
        <div className="flex h-full flex-col justify-between gap-6 text-white female:text-black">
            <div className="grid gap-6">
                <div className="self-start text-zing-24-32 font-semibold">{question.title}</div>
                <img className="h-auto w-full" src={question.img} />
            </div>
            <div className="sticky bottom-0 z-20 grid w-full justify-items-center gap-2 bg-zing-bg-sticky-39 pb-6 female:bg-zing-bg-sticky-39-white md:bg-zing-bg-sticky-30 md:pb-10 md:female:bg-zing-bg-sticky-30-white">
                {question.answers.map((answer, i) => (
                    <Button
                        key={answer.id}
                        onClick={handleContinue(answer.id)}
                        className={classNames({
                            "bg-zing-neutral-cool-grey-800 female:bg-zing-neutral-cool-grey-200 female:text-black":
                                i,
                        })}
                    >
                        {answer.text}
                    </Button>
                ))}
            </div>
        </div>
    );
};

export default YesNoWithImage;
